export default __webpack_public_path__ + "static/media/sticker-i.2288c6e4.png";